export { default } from './MedicalRecordsTable';
